// Generated by CoffeeScript 2.7.0
var StyleGuidesController;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import {
  newSpinner
} from 'trunks/vue/admin/components/spinner.js';

import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

import MaterialLibraryModal from 'trunks/vue/admin/components/modals/material_library_modal.js';

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import MaterialLibrary from 'trunks/vue/admin/components/material_library.js';

import UserSearch from 'trunks/vue/admin/components/search/user.js';

import FilterOptions from 'trunks/vue/admin/components/filter_options.js';

import IconPicker from 'trunks/vue/admin/components/icon_color_picker.js';

import Paginator from 'trunks/vue/admin/components/paginator.js';

export default StyleGuidesController = class StyleGuidesController extends Skylark.App.BaseController {
  admin_material_lib() {
    this.material_lib_vm = new MaterialLibrary({
      el: DomMaster.find('#material_lib_container').node,
      propsData: {
        materialType: 'material',
        editable: true
      }
    });
    return this.material_lib_vm.$on('typeChanged', (type) => {
      this.material_lib_vm.materialType = type;
      return this.material_lib_vm.updateMaterials();
    });
  }

  admin_richtext() {
    return new Skylark.Elements.Editor(document.getElementById('richtext_container'));
  }

  admin_group_options() {
    var groupedOptions;
    groupedOptions = [
      {
        multiple: true,
        options: [
          {
            id: 1,
            name: 'First',
            _selected: true
          },
          {
            id: 2,
            name: 'Second',
            _selected: false
          }
        ]
      },
      {
        name: 'Second group name',
        multiple: true,
        allow_clear: false,
        options: [
          {
            id: 3,
            name: 'Third',
            _selected: true
          },
          {
            id: 4,
            name: 'Fourt',
            _selected: true
          },
          {
            id: 5,
            name: 'Fifth',
            _selected: true
          }
        ]
      },
      {
        name: 'Group name',
        allow_clear: false,
        options: [
          {
            id: 6,
            name: 'Sixth',
            _selected: true
          },
          {
            id: 7,
            name: 'Seventh',
            _selected: false
          }
        ]
      }
    ];
    window.groupedVm = new GroupOptions({
      el: '#group_options_el',
      propsData: {
        groupedOptions: groupedOptions
      }
    });
    groupedVm.$on('valueChanged', function(vm) {
      return console.log(_.pluck(vm.getSelectedOptions(), 'name'));
    });
    return window.filterOptionsVm = new FilterOptions({
      el: '#group_options_filter_el',
      propsData: {
        groupedOptions: groupedOptions
      }
    });
  }

  admin_search() {
    window.userSearchVm = new UserSearch({
      el: '#search_el',
      propsData: {
        remote: '/admin/users/query',
        keyword: '1'
      }
    });
    return userSearchVm.$on('valueChanged', function(vm) {
      return console.log(vm.selectedItems);
    });
  }

  admin_components() {
    var ModalInstance;
    document.body.proxy('click', '.js_show_spinner', function(event) {
      var spinner;
      spinner = newSpinner({
        size: 'large',
        loadingText: '正在加载中...'
      });
      return setTimeout(function() {
        return spinner.close();
      }, 3000);
    });
    new Skylark.Elements.Switch(DomMaster.find('.js-switch-input'), {
      switchOnFunc: function() {
        return newAlertify('switch on');
      },
      switchOffFunc: function() {
        return newAlertify('switch off');
      }
    });
    this._initDatetimepicker();
    ModalInstance = Vue.extend({
      components: {
        modal: Modal
      },
      data: function() {
        return {
          opend: true
        };
      },
      template: `<modal :title='title'>
  <div class="modal-body" v-html='body'></div>
</modal>`
    });
    document.body.proxy('click', '#modal_trigger', function(event) {
      var el, vm;
      el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('modal', document.body);
      return vm = new ModalInstance({
        el: el,
        data: {
          body: '<p>这是一点内容</p>',
          title: '模态框标题'
        }
      });
    }, false);
    document.body.proxy('click', '#confirm_trigger', function() {
      var vm;
      vm = newConfirm({
        icon: '<i class="slp-warning-circle-o"></i>',
        title: 'confirm标题',
        message: 'confirm信息',
        confirmButtonText: '确认文字',
        cancelButtonText: '取消文字',
        type: 'danger'
      });
      vm.$on('openedChange', function(newValue) {
        return console.log(newValue);
      });
      vm.$on('ensureClicked', function() {
        return console.log('确认');
      });
      vm.$on('cancelClicked', function() {
        return console.log('取消');
      });
      vm.$on('maskClicked', function() {
        return console.log('点击遮罩');
      });
      vm.$on('afterOpened', function() {
        return console.log('afterOpened');
      });
      return vm.$on('afterClosed', function() {
        return console.log('afterClosed');
      });
    }, false);
    document.body.proxy('click', '#exportable_modal_trigger', (event) => {
      var modal;
      modal = document.querySelector('#exportable_modal_container>.modal');
      modal.addClass('open');
      Skylark.Helpers.App.disableScrollOnBody();
      modal.querySelector('.closer').addEventListener('click', function(event) {
        modal.removeClass('open');
        return Skylark.Helpers.App.enableScrollOnBody();
      }, false);
      return modal.proxy('change', 'input[type=checkbox]', (event) => {
        var checked, table, tr;
        tr = event._target.closest('tr');
        table = tr.closest('table');
        checked = event._target.checked;
        if (tr.parentElement.tagName.toLowerCase() === 'thead') {
          this._toggleSelectAll(table, checked);
        } else {
          this._toggleSelectItem(tr, checked);
        }
        if (table.querySelector('input[type=checkbox]:checked')) {
          return table.closest('.exportable-table').addClass('item-checked');
        } else {
          return table.closest('.exportable-table').removeClass('item-checked');
        }
      });
    });
    document.body.proxy('click', '#material_modal_trigger', function(event) {
      var el, modal, vm;
      if (document.querySelector('#material_lib')) {
        modal = document.querySelector('#material_lib>.modal');
        modal.addClass('open');
        Skylark.Helpers.App.disableScrollOnBody();
        return _.each(modal.querySelectorAll('.closer'), function(item) {
          return item.addEventListener('click', function(event) {
            modal.removeClass('open');
            return Skylark.Helpers.App.enableScrollOnBody();
          }, false);
        });
      } else {
        el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('material_lib', document.body);
        return vm = new MaterialLibraryModal({
          el: el,
          data: {
            opened: true,
            materialType: 'image'
          },
          propsData: {
            title: '素材库',
            ensureText: '插入',
            editable: false
          }
        });
      }
    });
    _.each(DomMaster.findAll("[data-comp='Alert']"), function(item) {
      return item.node.proxy('click', 'button', function(event) {
        var alertify_attrs, message, options;
        alertify_attrs = ['type', 'showIcon', 'textButton', 'description', 'showButtons', 'ensureText', 'cancelText', 'duration', 'closable'];
        options = {};
        message = item.data("message");
        _.each(alertify_attrs, function(attr) {
          if (item.data(attr)) {
            return options[attr] = item.data(attr);
          }
        });
        _.extend(options, {
          closeCallback: function() {
            return console.log(`${message} close`);
          },
          ensureCallback: function() {
            return console.log(`${message} ensure`);
          },
          cancelCallback: function() {
            return console.log(`${message} cancel`);
          },
          textButtonCallback: function() {
            return console.log(`${message} clickText`);
          }
        });
        return newAlertify(message, options);
      }, false);
    });
    this._initIconPicker();
    $currentController.vuePaginator = new Paginator({
      el: DomMaster.find('.js-vue-paginator').node,
      propsData: {
        resourceUrl: location.pathname,
        additionalParams: {
          total_pages: 100
        }
      }
    });
    // reverseTheme: true
    return new Skylark.Elements.ConfirmPopover(DomMaster.find('.js-confirm-popover'), {
      confirmFunc: function() {
        return newAlertify('confirmed');
      }
    });
  }

  _initIconPicker() {
    var IconColorPicker, el;
    el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('icon_picker_container');
    IconColorPicker = Skylark.Vue.Admin.Components.IconColorPicker;
    return new IconColorPicker({
      el: el,
      propsData: {
        pickerMode: 'icon'
      },
      data: {
        icon: 'fa-chrome'
      }
    });
  }

  _toggleSelectAll(table, checked) {
    if (checked) {
      return _.each(table.querySelectorAll('tbody input[type=checkbox]'), function(input) {
        return input.checked = true;
      });
    } else {
      return _.each(table.querySelectorAll('tbody input[type=checkbox]'), function(input) {
        return input.checked = false;
      });
    }
  }

  _toggleSelectItem(tr, checked) {
    var tbody, unselected;
    tbody = tr.closest('tbody');
    if (checked) {
      unselected = tbody.querySelectorAll('input[type=checkbox]:not(:checked)');
      if (unselected.length) {
        return;
      }
      return tbody.closest('table').querySelector('thead input[type=checkbox]').checked = true;
    } else {
      return tbody.closest('table').querySelector('thead input[type=checkbox]').checked = false;
    }
  }

  _initDatetimepicker() {
    var datetime_picker_input_el;
    datetime_picker_input_el = DomMaster.find('.js-datetime-picker-input');
    return new Skylark.Elements.DatetimePickerPopover(DomMaster.find('#js_datetimepicker_popover'), {
      initValue: datetime_picker_input_el.node.value,
      limitStart: new Date().yesterday(2),
      ensureCallback: function(value) {
        datetime_picker_input_el.node.value = value != null ? value.strftime() : void 0;
        return newAlertify(value);
      }
    });
  }

};

Skylark.App.Controllers.register({StyleGuidesController});
